import { render, staticRenderFns } from "./FieldColor.vue?vue&type=template&id=60240c44&scoped=true&"
import script from "./FieldColor.vue?vue&type=script&lang=js&"
export * from "./FieldColor.vue?vue&type=script&lang=js&"
import style0 from "./FieldColor.vue?vue&type=style&index=0&id=60240c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60240c44",
  null
  
)

export default component.exports